import PlayerShortModel from "../../Player/PlayerShortModel";

export default class TimelineModel {
    public minute: string = "";
    public type: string = "";
    public teamId: string = "";
    public player: PlayerShortModel = null;
    public relatedPlayer: PlayerShortModel = null;
    public updatedAt: string = "";
}